import SimpleModal from '@/ui/SimpleModal';
import { X } from '@phosphor-icons/react/dist/ssr';
import classNames from 'classnames';
import type { CSSProperties } from 'react';
import { emailCapturePopupContentContainer, emailCapturePopupDialogContent } from './EmailCapturePopup.css';
import type { EmailCapturePopupElementProps } from './EmailCapturePopup.types';

export function EmailCapturePopupElement(props: EmailCapturePopupElementProps) {
  const {
    children,
    element,
    isOpen = false,
    isPreviewing = false,
    onOpenChange,
    attributes,
    previewViewport,
    placement,
  } = props;

  const {
    width,
    maxWidth,
    gap,
    padding,
    backgroundColor,
    borderRadius,
    borderWidth,
    borderColor,
    borderStyle,
    modalOverlayBackgroundColor,
    modalCloseButtonColor = 'inherit',
    modalCloseButtonPlacementTop,
    modalCloseButtonPlacementRight,
  } = element.attrs || {};

  const generatedStyle = {
    '--overlay-background-color': modalOverlayBackgroundColor,
    '--modal-close-button-color': modalCloseButtonColor,
    '--modal-close-button-placement-top': modalCloseButtonPlacementTop || '24px',
    '--modal-close-button-placement-right': modalCloseButtonPlacementRight || '24px',
  } as CSSProperties;

  const renderedElement = (
    <div
      className={classNames(emailCapturePopupContentContainer, 'flex flex-col h-auto')}
      style={
        {
          '--width': width,
          '--max-width': maxWidth,
          backgroundColor,
          padding,
          borderStyle,
          borderWidth,
          borderRadius,
          borderColor,
          gap,
          '--padding': padding,
        } as CSSProperties
      }
    >
      {children}
    </div>
  );

  if (isPreviewing) {
    return (
      <div
        className={classNames(
          'w-full h-full flex justify-center relative',
          previewViewport === 'mobile' ? 'items-end' : 'items-center',
        )}
        style={generatedStyle}
        {...attributes}
      >
        <div className="absolute top-0 left-0 w-full h-full bg-[--overlay-background-color]">&nbsp;</div>
        <div className="z-10 relative">
          {renderedElement}
          <button
            type="button"
            className={classNames(
              'absolute right-[--modal-close-button-placement-right] top-[--modal-close-button-placement-top] rounded-sm opacity-70',
              'hover:opacity-100 transition-opacity',
              'focus:outline-none focus:ring-2 focus:ring-offset-2',
              'text-[--modal-close-button-color]',
            )}
            aria-label="Close"
          >
            <X className="h-4 w-4" />
          </button>
        </div>
      </div>
    );
  }

  if (!isOpen) {
    return null;
  }

  return (
    <SimpleModal
      isOpen={isOpen}
      onClose={onOpenChange}
      style={generatedStyle}
      placement={placement}
      mobilePlacement={placement}
    >
      <div className={classNames(emailCapturePopupDialogContent)} {...attributes}>
        {renderedElement}
      </div>
    </SimpleModal>
  );
}
